import { useQuery } from 'react-query';
import { documentsService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';
import { GetDocumentForFlexWorkerResponse } from 'hq/services/documents-service.types';
import { DocumentType } from '../documents-page/table/documents-table.types';

export const useGetDocumentForFw = (flexWorkerId: string, documentType: DocumentType) => {
  return useQuery<GetDocumentForFlexWorkerResponse | null, Error>({
    queryKey: QUERY_KEYS.documentForFlexWorker(flexWorkerId, documentType),
    queryFn: () => {
      return documentsService.findDocumentForFlexWorker(flexWorkerId, documentType);
    },
    enabled: !!flexWorkerId && !!documentType,
  });
};
